<template>
    <div v-if="!loading" id="survey">
        <div id="questionnaire">
            <nav class="questions-buttons" id="questionnaire-nav">
                <div>
                    <button type="button" class="btn-prev" @click="back" :disabled="current === 0">◄</button>
                </div>
                <div class="questionnaire-progress">
                    <div :style="{width: `${progress_value / get_total_weight(schema.questions) * 100}%`}"></div>
                </div>
                <div>
                    <button type="button" v-if="(current + 1) < schema.questions.length" class="btn-next" @click="next"
                            :disabled="!next_available">►
                    </button>
                </div>
            </nav>
            <div class="questions-container-wrapper" :style="{height: screen_height ? `${screen_height}px` : 'auto'}">
                <div class="questions-container" :data-total="schema.questions.length" :data-current="current"
                     :class="{'animation-in-progress': animation}">
                    <div v-for="(question, i) in schema.questions" :class="{'current': i === current}" v-bind:key="i">
                        <div>
                            <Question :question="question" :callback="set_done_status" :key="question.id" :do_shuffle="!loaded_from_local" />
                            <div :class="{'btn-ext-wrapper': true, 'btn-ext-wrapper-center': question.mode === 'message'}">
                                <button type="button" v-if="(i + 1) < schema.questions.length" class="btn-next"
                                        @click="next"
                                        :disabled="!next_available">Next
                                </button>
                                <button type="button" v-else class="btn-next" @click="submit" :disabled="!next_available">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Loader v-else></Loader>
</template>

<script>
  import Ajax from './../utils/Ajax';
  import Question from './Question';
  import Loader from './Loader';
  import Helpers from './../utils/Helpers';

  export default {
    name: 'Survey',
    props: ['callback', 'access_token'],
    data: function () {
      return {
        'screen_height': null,
        'session': null,
        'section': 0,
        'progress': 0,
        'schema': null,
        'progress_data': {},
        'progress_value': 0,
        'current': 0,
        'next_available': false,
        'loading': true,
        'loaded_from_local': false,
        'animation': 0,
        'pop_state': this.change_pop_state.bind(this),
        'service': 'default',
      }
    },
    components: {
      Question, Loader
    },
    beforeMount: function () {
      this.init_session();
    },
    mounted: function() {
      this.$parent.$data.close_ask = true;
      this.count_screen_height();
      window.addEventListener('popstate', this.$data.pop_state);
      window.addEventListener('resize', this.count_screen_height);
    },
    beforeDestroy: function () {
      window.removeEventListener('popstate', this.$data.pop_state);
      window.removeEventListener('resize', this.count_screen_height)
    },
    methods: {
      'init_session': function (password) {
        const params = [];
        const service = Helpers.get_search_string()['s'];
        if (service){
          if (['dating'].includes(service)) {
            params.push(`s=${encodeURIComponent(service)}`);
            this.$data.service = service;
          }
        }
        const utm_source = Helpers.get_search_string()['utm_source'];
        if (utm_source){
          params.push(`utm_source=${encodeURIComponent(utm_source)}`);
        }
        if (password) {
          params.push(`password=${encodeURIComponent(password)}`);
        }
        Ajax.ajax('GET', `${this.API_BASE}/survey${params.length ? ('?' + params.join('&')) : ''}`).then((r) => {
          const version = r.response.version;
          this.$data.session = r.response.session;
          this.$parent.$data.session = r.response.session;
          const url = `${this.SCHEMA_STORAGE}/${version}.json`;
          Ajax.ajax('GET', url).then((r) => {
            let schema = r.response;
            let draft = localStorage.getItem(`hoo-r-u-draft-${this.$data.service}`);
            if (draft){
              window.gtag && window.gtag('event', 'questionnaire-action', {
                'event_category': 'draft'
              });
              draft = JSON.parse(draft);
              if (draft && draft['schema'] && (draft['schema']['version'] === schema['version'])) {
                schema = draft['schema'];
                this.$data.loaded_from_local = true;
                this.$data.current = draft['current'];
                this.$data.progress_data = draft['progress_data'];
              }
            } else {
              window.gtag && window.gtag('event', 'questionnaire-action', {
                'event_category': 'start'
              });
            }
            this.$data.schema = schema;
            this.$data.loading = false
            setTimeout(() => {
              this.$children[this.$data.current].$children[0].update_done_status()
              this.recount_progress()
            }, 10)
            navigator.sendBeacon && navigator.sendBeacon(`${this.API_BASE}/stats/${this.$data.session}`, JSON.stringify({
              'name': 'STEP',
              'value': this.$data.current
            }));
            window.gtag && window.gtag('event', 'questionnaire-action', {
              'event_category': 'step',
              'event_label': `step-${this.$data.current}`,
            });
            setTimeout(() => {
              this.count_screen_height();
            }, 1);
          }).catch((e) => {
            alert('Something went wrong. Please, refresh the page.')
          });
        }).catch(r => {
          if (r.status === 401){
            let pwd = localStorage.getItem('hooru-dev-password');
            if (!pwd) {
              pwd = prompt('Please, provide password');
              if (pwd){
                localStorage.setItem('hooru-dev-password', pwd);
              }
            }
            this.init_session(pwd);
          } else {
            alert('Something went wrong. Please, refresh the page.')
          }
        });
      },
      'count_screen_height': function () {
        const qCurrent = document.querySelector('.questions-container > .current > div');
        const header = document.querySelector('header');
        const footer = document.querySelector('footer');
        const nav = document.querySelector('nav');
        if (qCurrent) {
          this.$data.screen_height = Math.max(qCurrent.clientHeight, window.innerHeight - header.clientHeight - nav.clientHeight - footer.clientHeight - 1);
        }
      },
      'change_pop_state': function (e) {
        if (!e.state){
          return;
        }
        if (e.state['survey_step']){
          e.preventDefault();
          this.nav(e.state['survey_step'] - this.$data.current, true);
        } else if (e.state['step']){
          e.preventDefault();
          this.$parent.$data.step = e.state['step'];
        }
      },
      'back': function () {
        this.nav(-1);
      },
      'next': function () {
        this.nav(1);
      },
      'nav': function (f, no_push) {
        this.$data.animation = (this.$data.animation + 1);
        window.scrollTo(0,0);
        setTimeout(() => {
          this.$data.animation = (this.$data.animation - 1);
          this.count_screen_height();
        }, 1000);
        this.$data.current = this.$data.current + f;
        navigator.sendBeacon && navigator.sendBeacon(`${this.API_BASE}/stats/${this.$data.session}`, JSON.stringify({
          'name': 'STEP',
          'value': this.$data.current
        }));
        window.gtag && window.gtag('event', 'questionnaire-action', {
          'event_category': 'step',
          'event_label': `step-${this.$data.current}`,
        });
        if (!no_push) {
          window.history.pushState({'step': 'survey', 'survey_step': this.$data.current}, document.getElementsByTagName('title')[0].innerHTML, "");
        }
        this.$children[this.$data.current].$children[0].update_done_status();
        this.recount_progress();
      },
      'recount_progress': function () {
        this.$data.progress_value = Object.values(this.$data.progress_data).reduce((v, t) => v + t);
      },
      'submit': function (e) {
        e.preventDefault();
        this.$data.loading = true;
        this.send_answers().then((r) => {
          localStorage.removeItem(`hoo-r-u-draft-${this.$data.service}`);
          this.$props.callback(r.response.access_token, r.response.price);
        }).catch(() => {
          alert('Error, please try again');
          this.$data.loading = false;
        });
      },
      'set_done_status': function (event) {
        this.$data.next_available = event.status;
        let q_n = null;
        for (let i in this.$data.schema.questions){
          if (this.$data.schema.questions[i]['id'] === event.id) {
            q_n = i;
          }
        }
        if (this.$data.schema.questions[q_n]) {
          this.$data.progress_data[event.id] = event.status ? this.count_progress_weight(this.$data.schema.questions[q_n]) : 0;
          this.$data.schema.questions[q_n].value = event.value;
        } else {
          alert('Something went wrong, question not found');
        }
        this.recount_progress();
        localStorage.setItem(`hoo-r-u-draft-${this.$data.service}`, JSON.stringify({
          'schema': this.$data.schema,
          'progress_data': this.$data.progress_data,
          'current': this.$data.current
        }));
      },
      'count_progress_weight': function (question) {
        let weight = (question.mode === 'message' ? 0 : 9);
        if (question.options && question.options.items) {
          weight += question.options.items.length * (question.mode === 'rate' ? 6 : 3);
        }
        return weight;
      },
      'get_total_weight': function (questions) {
        let total = 0;
        for (let i in questions) {
          total += this.count_progress_weight(questions[i]);
        }
        return total;
      },
      'send_answers': function () {
        navigator.sendBeacon && navigator.sendBeacon(`${this.API_BASE}/stats/${this.$data.session}`, JSON.stringify({
          'name': 'SUBMIT',
          'value': null
        }));
        window.gtag && window.gtag('event', 'questionnaire-action', {
          'event_category': 'submit'
        });
        let answers = {};
        for (let i in this.$data.schema['questions']) {
          answers[this.$data.schema['questions'][i]['id']] = this.$data.schema['questions'][i]['value'];
          if (this.$data.schema['questions'][i]['options'] && this.$data.schema['questions'][i]['options']['flags'] && this.$data.schema['questions'][i]['options']['flags'].includes('fd')){
            answers['@' + this.$data.schema['questions'][i]['id']] = this.$data.schema['questions'][i]['options']['items'].map((v) => {
              return this.$data.schema['questions'][i]['value'][v['id']];
            });
          }
        }
        return Ajax.ajax('POST', `${this.API_BASE}/survey/${this.$data.session}`, answers);
      }
    }
  }
</script>

<style scoped>
    nav {
        position: fixed;
        z-index: 4;
        top: 5rem;
        left: 0;
        right: 0;
        box-shadow: 0 -1px 0 #dddddd inset;
        box-sizing: border-box;
    }

    #survey {
        position: relative;
        min-height: 100%;
    }

    #questionnaire {
        padding-top: 3rem;
    }

    .questionnaire-progress {
        width: 100%;
        height: 3rem;
        background: rgba(255, 255, 255, 0.5);
    }

    .questionnaire-progress > * {
        height: 100%;
        background: #8fbd52;
        transition: width 1s linear;
    }

    .questions-buttons {
        display: flex;
    }

    .questions-buttons button {
        width: 4rem;
        height: 3rem;
        line-height: 3rem;
        padding: 0;
        text-align: center;
        outline: none;
        cursor: pointer;
        font-size: 1.8rem;
        background: transparent;
        color: #ffe6a3;
        font-family: sans-serif;
    }

    .questions-buttons button[disabled="disabled"] {
        display: none;
    }

    .questions-buttons:nth-child(1) {
        width: 100%;
    }

    .questions-buttons > *:first-child {
        position: absolute;
        left: 0;
    }

    .questions-buttons > *:last-child {
        position: absolute;
        right: 0;
    }

    .questions-container-wrapper {
        width: 100%;
        overflow: hidden;
    }

    .questions-container {
        display: flex;
        height: 100%;
        transition: margin-left ease 1s;
    }

    .questions-container[data-total="1"] {
        width: 100%;
    }

    .questions-container[data-total="2"] {
        width: 200%;
    }

    .questions-container[data-total="3"] {
        width: 300%;
    }

    .questions-container[data-total="4"] {
        width: 400%;
    }

    .questions-container[data-total="5"] {
        width: 500%;
    }

    .questions-container[data-total="6"] {
        width: 600%;
    }

    .questions-container[data-total="7"] {
        width: 700%;
    }

    .questions-container[data-total="8"] {
        width: 800%;
    }

    .questions-container[data-total="9"] {
        width: 900%;
    }

    .questions-container[data-total="10"] {
        width: 1000%;
    }

    .questions-container[data-total="11"] {
        width: 1100%;
    }

    .questions-container[data-total="12"] {
        width: 1200%;
    }

    .questions-container[data-total="13"] {
        width: 1300%;
    }

    .questions-container[data-total="14"] {
        width: 1400%;
    }

    .questions-container[data-total="15"] {
        width: 1500%;
    }

    .questions-container[data-total="16"] {
        width: 1600%;
    }

    .questions-container[data-current="1"] {
        margin-left: -100%;
    }

    .questions-container[data-current="2"] {
        margin-left: -200%;
    }

    .questions-container[data-current="3"] {
        margin-left: -300%;
    }

    .questions-container[data-current="4"] {
        margin-left: -400%;
    }

    .questions-container[data-current="5"] {
        margin-left: -500%;
    }

    .questions-container[data-current="6"] {
        margin-left: -600%;
    }

    .questions-container[data-current="7"] {
        margin-left: -700%;
    }

    .questions-container[data-current="8"] {
        margin-left: -800%;
    }

    .questions-container[data-current="9"] {
        margin-left: -900%;
    }

    .questions-container[data-current="10"] {
        margin-left: -1000%;
    }

    .questions-container[data-current="11"] {
        margin-left: -1100%;
    }

    .questions-container[data-current="12"] {
        margin-left: -1200%;
    }

    .questions-container[data-current="13"] {
        margin-left: -1300%;
    }

    .questions-container[data-current="14"] {
        margin-left: -1400%;
    }

    .questions-container[data-current="15"] {
        margin-left: -1500%;
    }

    .questions-container[data-current="16"] {
        margin-left: -1600%;
    }

    .questions-container > * {
        width: 100%;
        position: relative;
    }

    .questions-container > * > * {
        box-sizing: border-box;
        padding: 2rem;
        max-width: 1200px;
        margin: 0 auto;
    }

    @media only screen and (max-width: 640px){

        .questions-container > * > *{
            padding: 1.5rem 1.5rem 7rem 1.5rem;
        }

    }

    @media only screen and (min-width: 1024px) {
        .questions-container > * > *{
            padding: 3rem;
        }
    }

</style>
